/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCommissionStatementDto, serializeDisputeCommissionStatementRequest, type CommissionStatementDto, type DisputeCommissionStatementRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}/dispute
 */
export interface DisputeRequestBuilder extends BaseRequestBuilder<DisputeRequestBuilder> {
    /**
     * Moves a statement to Disputed, from either InReview or Approved — approving a statement does not put it beyond challenge, and only marking it paid does. A Pending statement cannot be disputed; submit it for review first. `reason` is required and must not be blank: it is written verbatim into the statement's history, and is the only record of why the figures were challenged, so make it specific. Disputing changes no amounts — a statement's entries are fixed once generated, so settling a dispute over the numbers means generating a replacement statement rather than editing this one. From Disputed the only move is back to review.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DisputeCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Moves a statement to Disputed, from either InReview or Approved — approving a statement does not put it beyond challenge, and only marking it paid does. A Pending statement cannot be disputed; submit it for review first. `reason` is required and must not be blank: it is written verbatim into the statement's history, and is the only record of why the figures were challenged, so make it specific. Disputing changes no amounts — a statement's entries are fixed once generated, so settling a dispute over the numbers means generating a replacement statement rather than editing this one. From Disputed the only move is back to review.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DisputeCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DisputeRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}/dispute";
/**
 * Metadata for all the requests in the request builder.
 */
export const DisputeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DisputeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDisputeCommissionStatementRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
